import type { WorldEntity } from '../../engine/world/types';

export const mockUnits: readonly WorldEntity[] = [];
